// extracted by mini-css-extract-plugin
export default {"videoOuter":"index-module__aGYYn"};